import { types } from './type';
import API from '../api';
const { assetList, InYardList, closedOut,ticketDetails,yardTicketPerforma } = API;

export const getAssetList = () => (dispatch, getstate) => {
  const prevState = getstate().myYard.assetList;
  if (prevState.length === 0) {
    dispatch({ type: types.SHOW_LOADING, loading: true });
  }
  let data = JSON.parse(localStorage.getItem('data'));
  let arr = data.TabParams.filter((item) =>
    ['Rejected', 'Check-In'].includes(item.param_name)
  );
  let check_in = arr[0].param_value;
  let status = arr[1].param_value;
  assetList(check_in, status)
    .then((resp) => {
      dispatch({
        type: types.ASSET_LIST,
        data: resp.data.data,
      });
    })
    .catch((er) => {
      dispatch({ type: types.SHOW_LOADING, loading: false });
    });
};

export const getInYardList = () => (dispatch, getstate) => {
  const prevState = getstate().myYard.inYardList;
  if (prevState.length === 0) {
    dispatch({ type: types.SHOW_LOADING, loading: true });
  }
  InYardList()
    .then((resp) => {
      dispatch({
        type: types.INYARD_LIST,
        data: resp.data.data.rows,
      });
    })
    .catch((er) => {
      dispatch({ type: types.SHOW_LOADING, loading: false });
    });
};
export const getClosedOutList = () => (dispatch,getstate) => {
  const prevState = getstate().myYard.closedOutList;
  if (prevState.length === 0) {
    dispatch({ type: types.SHOW_LOADING, loading: true });
  }
  let data = JSON.parse(localStorage.getItem('data'));
  let pikdup = data.TabParams.filter(
    (item) => item.param_name === 'Checkout'
  );

  let pikdupValue = pikdup[0].param_value;
  closedOut(pikdupValue)
    .then((resp) => {
      dispatch({
        type: types.CLOSEDOUT_LIST,
        data: resp.data.data,
      });
    })
    .catch((er) => {
      dispatch({ type: types.SHOW_LOADING, loading: false });
    });
};
let ticketDetailsId=""
export const getTicketDetails = (ticket_id) => (dispatch,getstate) => {
  const prevState = getstate().myYard.ticketDetails;
  if (prevState.length === 0) {
    dispatch({ type: types.SHOW_LOADING, loading: true });
  }else if(ticketDetailsId!==ticket_id) {
    dispatch({ type: types.SHOW_LOADING, loading: true });
  }
  ticketDetails(ticket_id)
    .then((resp) => {
      ticketDetailsId=ticket_id
      dispatch({
        type: types.TICKET_DETAILS,
        data: resp.data.data,
      });
    })
    .catch((er) => {
      dispatch({ type: types.SHOW_LOADING, loading: false });
    });
};


let proformaID=""
export const getProforma = (ticket_id) => (dispatch,getstate) => {
  const prevState = getstate().myYard.proformaData;
  if (prevState===null) {
    dispatch({ type: types.PROFORMA_LOAD, loading: true });
  }else if(proformaID!==ticket_id) {
    dispatch({ type: types.PROFORMA_LOAD, loading: true });
  }
  yardTicketPerforma(ticket_id)
    .then((resp) => {
      proformaID=ticket_id
      dispatch({
        type: types.PROFORMA_DATA,
        data: resp.data.data,
      });
    })
    .catch((er) => {
      dispatch({ type: types.PROFORMA_LOAD, loading: false });
    });
};
